import React from "react";
import classnames from "classnames/bind";

import styles from "./ProgressBar.module.css";

const cx = classnames.bind(styles);

type Props = {
  progress: number;
};

export const ProgressBar: React.FC<Props> = (props) => {
  return (
    <div
      className={cx("progress-bar")}
      style={{
        width: `${props.progress * 100}%`,
      }}
    />
  );
};
